import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Divider, Image, Row, Space} from 'antd';
import {EnvironmentOutlined, LinkOutlined, MailOutlined, PhoneOutlined} from '@ant-design/icons';
import StoreActions from "bukku/redux/Store/actions";
import StyledDrawer from './style';
// import styled from 'styled-components';

const { toggleStoreInfoDrawer } = StoreActions;

class StoreInfoDrawer extends Component {
    renderDetails = () => {
        const {
            store,
        } = this.props;

        return (
            <>
                {store.url && (
                    <Row>
                        <Col span={3}>
                            <LinkOutlined />
                        </Col>
                        <Col span={21}>
                            <a href={store.url} target="_blank" rel="noopener noreferrer">{store.url}</a>
                        </Col>
                    </Row>
                )}
                {store.email && (
                    <Row>
                        <Col span={3}>
                            <MailOutlined />
                        </Col>
                        <Col span={21}>
                            <a
                                href={`mailto:${store.email}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {store.email}

                            </a>
                        </Col>
                    </Row>
                )}
                {store.phoneNo && (
                    <Row>
                        <Col span={3}>
                            <PhoneOutlined />
                        </Col>
                        <Col span={21}>
                            <span>{store.phoneNo}</span>
                        </Col>
                    </Row>
                )}
                {store.billingAddress &&
                <Row>
                    <Col span={3}>
                        <EnvironmentOutlined />
                    </Col>
                    <Col span={21}>
                        <span className="pre-wrap">{store.billingAddress.text}</span>
                    </Col>
                </Row>}
            </>
        );
    };

    render() {
        const {
            store,
            storeInfoDrawerVisible,
            toggleStoreInfoDrawer,
        } = this.props;

        return (
            // <StyledDrawer>
            <StyledDrawer
                title="About Us"
                open={storeInfoDrawerVisible}
                onClose={() => toggleStoreInfoDrawer(false)}
            >
                <Row gutter={[12, 12]}>
                    {store.logoUrl && (
                        <Col span={24}>
                            <Image preview={false} src={store.logoUrl} alt={store.friendlyName} />
                        </Col>
                    )}
                    <Col span={24}><h3>{store.friendlyName}</h3></Col>
                </Row>

                <Divider />

                <Space direction="vertical">
                    {this.renderDetails()}
                </Space>
            </StyledDrawer>
            // </Styled>
        );
    }
}

export default connect(state => ({
    store: state.Store.store,
    storeInfoDrawerVisible: state.Store.storeInfoDrawerVisible,

}), {
    toggleStoreInfoDrawer,
})(StoreInfoDrawer);
